import http from '@axios'
import paramsConverter from './utils/paramsConverter'

const resource = '/api/v1/bank-icon'

export default {
  list(params = {}) {
    const paramsString = paramsConverter(params)

    return http.get(`${resource}${paramsString}`)
  },
  edit(uuid) {
    return http.get(`${resource}/${uuid}`)
  },
  get(uuid) {
    return http.get(`${resource}/${uuid}`)
  },
  update(bankicon, uuid) {
    return http.post(`${resource}/update-icon-tag/${uuid}?_method=PATCH`, bankicon, {
      headers: { 'Content-Type': 'multipart/form-data' },
    })
  },
  destroy(uuid) {
    return http.delete(`${resource}/${uuid}`)
  },
}
